var map = {
	"./bigCircle.svg": "8d47",
	"./circlesRect.svg": "c8a0",
	"./example.jpg": "fdcb",
	"./instagram.svg": "0d76",
	"./quoteBottomRight.svg": "5def",
	"./quoteTopLeft.svg": "b50f",
	"./slideArrow.svg": "4296",
	"./smallCircle.svg": "fd01",
	"./telegram.svg": "7d73",
	"./twitter.svg": "be6f",
	"./vkontakte.svg": "5300"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "abaa";